import apiClient from '../apiClient';
import { GET_TRANSACTION_PAYMENT_TERM_BY_TRANSACTION_ID_URL } from '../apiUrl';

const getPaymentTermByTransactionIdApi = Id => {
  return apiClient.get(GET_TRANSACTION_PAYMENT_TERM_BY_TRANSACTION_ID_URL(Id));
};

export default getPaymentTermByTransactionIdApi;
